/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';

// default static assets
import mpaOverview from '../../static/img/mpa_overview_report.png';
import mpaDetail from '../../static/img/mpa_detail_report.png';
import averageSavings from '../../static/img/average_savings_report.png';

class StaticMockup extends React.PureComponent {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    const id = params.get('rid');
    const report = props.reports.find((r) => r.id === id) || {};
    this.state = {
      id,
      tabs: (report.tabs || []),
      selectedTab: 0,
    };
  }

  render() {
    const { id, selectedTab } = this.state;
    const tabs = this.state.tabs || [];
    return (
      <main style={{ backgroundColor: '#f6f6f6' }}>
        <div className="col ps-0">
          <div className="row pt-3 mx-0 ps-2">
            {tabs.map((tab, index) => {
              return (
                <>
                  <div
                    className="btn btn-sm text-muted"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ selectedTab: index });
                    }}
                  >
                    {tab.name}
                  </div>
                  <div className="btn btn-sm">|</div>
                </>
              );
            })}
          </div>
          <img
            src={tabs[selectedTab]['url']}
            alt=""
            className=""
            style={{
              width: '100%',
            }}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (store) => ({
  reports: store.reports.reports,
});

export default connect(mapStateToProps)(StaticMockup);
